import { ReportSnapshot } from 'dashboard/models/report-snapshot';
import Action from 'lib/interfaces/Action';

export type ReportSnapshotActions = Action<
  ReportSnapshotActionType.SetReportSnapshot,
  SetReportSnapshotPayload
>;

export enum ReportSnapshotActionType {
  SetReportSnapshot = 'report-snapshot/SET_REPORT_SNAPSHOT',
}

interface SetReportSnapshotPayload {
  reportSnapshot: ReportSnapshot;
}

export function setReportSnapshot(
  reportSnapshot: ReportSnapshot,
): Action<ReportSnapshotActionType.SetReportSnapshot, SetReportSnapshotPayload> {
  return {
    payload: {
      reportSnapshot,
    },
    type: ReportSnapshotActionType.SetReportSnapshot,
  };
}
